import React, {Component, Fragment} from "react"
import styled from "styled-components"
import apps, {RECOGNITION} from "@irati-web/app/src/routeConfig"

import id from "@irati/utils/id"
import qs from "qs"
import GenericModal from "@irati/ui/src/GenericModal"
import {FormattedMessage} from "@irati/utils/lang"
import History, {appOrContext} from "@irati/utils/history"
import {IconTypes} from "@irati/ui/src/Icon"
import Button, {IconButton} from "@irati/ui/src/Button"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import CreatePoll from "@irati/recognition/apollo/mutation/Poll/Create"
import tracking from "@irati-tracking/recognition/poll"
import {EVERYONE, SPECIFIC_TEAMS} from "@irati/recognition/constants/share"
import Flex from "@irati/ui/src/Flex"

import {CancelConfirm, DatePicker} from "../shared"
import Create from "./Create"
import Inspire from "./Inspire"

export const CREATE = "CREATE"
export const INSPIRE = "INSPIRE"
export const TROPHY = "TROPHY"
export const DATE_PICKER = "DATE_PICKER"
export const CANCEL_CONFIRM = "CANCEL_CONFIRM"
export const INSPIRE_MODE = "inspire"
const modals = [CREATE, TROPHY, INSPIRE, DATE_PICKER, CANCEL_CONFIRM]

const EMPTY_POLL = {
  companyValues: [],
  teams: []
}

const Back = styled(IconButton)`
  position: absolute;
  top: 10px;
  left: 10px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
  top: 45px;
  left: 15px;
  `}
`

interface Props {
  onExited: () => void
  focusReward: boolean
}

interface State {
  share: string
  show: {[key: string]: string}
  poll: {[key: string]: string}
}

class CreatePollPopup extends Component<Props, State> {
  static defaultProps = {
    onExited: () => {},
    focusReward: false
  }

  constructor(props: Props) {
    super(props)
    const {mode} = qs.parse(location.search.replace("?", ""))
    this.state = {
      share: EVERYONE,
      show: modalStory(modals, mode === INSPIRE_MODE ? INSPIRE : CREATE, {}),
      poll: EMPTY_POLL
    }
  }

  // looks for any active popups, if none; we know its a new instance of popup so clear poll
  shouldClearPoll = () => !anyStoriesOpen(this.state.show)

  show = (modalToShow = CREATE) => {
    this.setState(({poll, show}) => ({
      show: modalStory(modals, modalToShow, show),
      poll: this.shouldClearPoll() ? EMPTY_POLL : poll
    }))
  }

  hide = () => {
    this.setState({show: modalStory(modals, null)})
  }

  cancelConfirm = () => {
    const {poll} = this.state
    if (poll === EMPTY_POLL) {
      this.hide()
    } else {
      this.show(CANCEL_CONFIRM)
    }
  }

  handleChange = (poll, key, value) => {
    this.setState({
      poll: {
        ...poll,
        [key]: value
      }
    })
  }

  handleInspire = (inspiration) => {
    this.setState(({poll}) => ({
      poll: {
        ...poll,
        ...inspiration
      }
    }))
    this.show(CREATE)
  }

  handlePollCreationComplete = () => {
    const {poll} = this.state
    tracking.createPoll(poll)
    this.hide()
  }

  handlePollError = (response) => {
    tracking.errorsPoll(response)
  }

  handleAfterExit = () => {
    if (!anyStoriesOpen(this.state.show)) {
      History.push(appOrContext({to: "/polls", app: apps[RECOGNITION]}, {}))
      this.props.onExited()
    }
  }

  handleSharingOptionChange = (share) => {
    if (share !== SPECIFIC_TEAMS) {
      this.handleChange(this.state.poll, "teams", [])
    }

    this.setState({
      share
    })
  }

  render() {
    const {show, poll, share} = this.state
    const {focusReward} = this.props
    if (!poll) {
      return null
    }

    return (
      <CreatePoll poll={poll} onCompleted={this.handlePollCreationComplete} onError={this.handlePollError}>
        {(onSubmit, apolloState) => (
          <Fragment>
            <GenericModal show={show[CREATE]} onHide={this.cancelConfirm} onExited={this.handleAfterExit} hideActions>
              <Create
                poll={poll}
                share={share}
                onChange={this.handleChange}
                onSubmit={onSubmit}
                onSharingOptionChange={this.handleSharingOptionChange}
                apolloState={apolloState}
                focusReward={focusReward}
                selectScreen={this.show}
              />
            </GenericModal>
            <GenericModal show={show[INSPIRE]} onHide={this.cancelConfirm} onExited={this.handleAfterExit} hideActions>
              <Back inline={false} icon={IconTypes.arrowLeft} onClick={() => this.show(CREATE)} />
              <Inspire onSelect={this.handleInspire} selectScreen={this.show} />
            </GenericModal>
            <GenericModal
              show={show[DATE_PICKER]}
              onHide={this.cancelConfirm}
              onExited={this.handleAfterExit}
              actions={
                <Flex justifyContent="flex-end" alignItems="center">
                  <Button tertiary marginRight={2} onClick={() => this.show(CREATE)}>
                    <FormattedMessage id="platform.button.goBack" />
                  </Button>
                  <Button id={id("save", this.props)} primary onClick={() => this.show(CREATE)}>
                    <FormattedMessage id="recognition.global.save" />
                  </Button>
                </Flex>
              }>
              <DatePicker poll={poll} onChange={this.handleChange} />
            </GenericModal>
            <GenericModal show={show[CANCEL_CONFIRM]} onExited={this.handleAfterExit} hideActions>
              <CancelConfirm previous={show.previous} selectScreen={this.show} onHide={this.hide} />
            </GenericModal>
          </Fragment>
        )}
      </CreatePoll>
    )
  }
}
export default CreatePollPopup
